module.exports = "<h6>Process ...</h6>"


//////////////////
// WEBPACK FOOTER
// D:/TMB/sr-git-v1/TMB.UI/src/app/pages/auth/callback/callback-login.component.html
// module id = ../../../../../src/app/pages/auth/callback/callback-login.component.html
// module chunks = main